module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"TBWA\\Media Arts Lab","short_name":"\\MAL","start_url":"/","background_color":"#000001","theme_color":"#f3f2f3","display":"minimal-ui","icon":"src/assets/images/icons/mal-logo_512.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"31fe99e52419abf033073badab87f62d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
